import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";

interface SectionToggleProps {
  label: string;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
  description?: string;
  count?: number;
  disabled?: boolean;
  className?: string;
}

/**
 * Section toggle control for enabling/disabling import sections
 *
 * Used in the unified onboarding flow to let users choose
 * which sections to import (Company, Bank Accounts, Vendors, Customers)
 */
export function SectionToggle({
  label,
  enabled,
  onToggle,
  description,
  count,
  disabled = false,
  className,
}: SectionToggleProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between p-3 rounded-lg border transition-colors",
        enabled ? "bg-muted/30 border-primary/20" : "bg-muted/10 border-muted",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
    >
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span
            className={cn("font-medium", !enabled && "text-muted-foreground")}
          >
            {label}
          </span>
          {count !== undefined && count > 0 && (
            <span className="text-xs text-muted-foreground px-1.5 py-0.5 rounded bg-muted">
              {count}
            </span>
          )}
        </div>
        {description && (
          <p className="text-sm text-muted-foreground mt-0.5 truncate">
            {description}
          </p>
        )}
      </div>
      <Switch
        checked={enabled}
        onCheckedChange={onToggle}
        disabled={disabled}
        aria-label={`Toggle ${label}`}
      />
    </div>
  );
}
